// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { EyeOff as RawEyeOff } from "lucide-react";
export const EyeOff = /* @__PURE__ */ createIcon(RawEyeOff, "EyeOff", 2);
